
  import { defineComponent, PropType } from 'vue';

  import { TDashboardsTableFilter } from '../../types/dashboards';
  import MinistryEventsTable from './MinistryEventsTable.vue';
  import PlannedEventsTable from './PlannedEventsTable.vue';

  export default defineComponent({
    name: 'DashboardsTables',
    emits: ['changePlannedEventsFilter'],
    components: {
      PlannedEventsTable,
      MinistryEventsTable,
    },
    props: {
      params: {
        type: Object as PropType<Partial<TDashboardsTableFilter>>,
      },
      isDatesColumnFirst: {
        type: Boolean,
        default: false,
      },
      editable: {
        type: Boolean,
        default: false,
      },
      hideSubjectFilter: {
        type: Boolean,
        default: false,
      },
      hideCountryFilter: {
        type: Boolean,
        default: false,
      },
      hideMinistryEvents: {
        type: Boolean,
        default: false,
      },
    },
  });
